// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.UsersRoleSetup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import connect from 'share/enhancers/Izenda.Connect';
import React, { Component, PropTypes } from 'react';
import { ROLE_SETUP } from 'logic/data/Izenda.RoleSetupConstants';
import UsersRoleItem from './Izenda.UsersRoleItem';
import Input from 'share/components/controls/Izenda.Input';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import LazyLoading from 'share/components/controls/LazyLoading/Izenda.LazyLoading';
import action from 'modules/Settings/RoleSetup/RoleDetail/Users/Izenda.UsersRoleSetupAction';

@connect(action)
export default class UsersRoleSetup extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    onCheckUser: PropTypes.func
  };

  constructor(props: any) {
    super(props);

    const { store } = props;
    this.registerLazyLoadingStore = store.registerLazyLoadingStore.bind(store);
    this.getData = props.getData.bind(null);
  }

  handleSearchUsers = (event: any) => {
    this.props.store.searchUsers(event.target.value);
  };

  renderUser = (user: any) => {
    const { onCheckUser, store } = this.props;

    return (
      <div className="izenda-CustomRow">
        <UsersRoleItem onCheckUser={onCheckUser} user={user} searchedUserName={store.model.searchedUserName} />
      </div>
    );
  };

  render() {
    const {
      localization,
      store: {
        lazyLoadingStore = {},
        model: {
          searchedUserName,
          usersList,
          isLastPage
        }
      }
    } = this.props;
    
    const usersData = usersList.length ? usersList : [];

    return (
      <div className="izenda-UsersRoleSetup u_fullHeight">
        <GridLayout className="u_paddingLeftRight">
          <GridLayout.Row>
            <GridLayout.Col cols="12">
              <p className="u_paddingAll">{ROLE_SETUP.USERS}</p>
              <div className="u_table u_fullSize u_borderAll">
                <div className="u_tableRow">
                  <div className="u_tableCell u_paddingAll u_borderBottom">
                    <i className="icon-useradmin" />
                    <label>{localization.getText('ROLE_SETUP_USERS_LABEL_ASSIGN_USERS')}</label>
                  </div>
                </div>
                <div className="u_tableRow">
                  <div className="u_tableCell u_paddingAll u_borderBottom">
                    <Input
                      placeholder={localization.getText('ROLE_SETUP_USERS_LABEL_SEARCH')}
                      value={searchedUserName}
                      onChange={this.handleSearchUsers}
                    />
                  </div>
                </div>
                <div className="u_tableRow">
                  <div className="u_tableCell u_fullSize">
                    <ScrollBox className="izenda-CustomContent-Container">
                      <LazyLoading
                        className="izenda-CustomContainerTable"
                        itemKey="id"
                        data={usersData}
                        isLastPage={isLastPage}
                        getData={this.getData}
                        renderItem={this.renderUser}
                        viewHeight={lazyLoadingStore.viewHeight}
                        itemHeight={lazyLoadingStore.itemHeight}
                        registerLazyLoadingStore={this.registerLazyLoadingStore}
                      />
                    </ScrollBox>
                  </div>
                </div>
              </div>
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/Users/Izenda.UsersRoleSetup.js